import Pusher from 'pusher-js';
import { pusherKey as key } from '@/utils/baseUrl';

let pusherInstance = null;
let channels = {};
let cluster = 'eu';
let options = { cluster };

export function initPusher() {
  if (!pusherInstance) {
    pusherInstance = new Pusher(key, options);
  }
  return pusherInstance;
}

export function subscribeToChannel(channelName, event, callback) {
  const pusher = initPusher();
  if (!channels[channelName]) {
    channels[channelName] = pusher.subscribe(channelName);
  }
  channels[channelName].bind(event, callback);
}

export function unsubscribeFromChannel(channelName) {
  if (channels[channelName]) {
    pusherInstance.unsubscribe(channelName);
    delete channels[channelName];
  }
}

export function unsubscribeEvent(channelName, event, callback) {
  if (channels[channelName]) {
    channels[channelName].unbind(event, callback);
    // Do NOT unsubscribe the whole channel here
  }
}
